'use client';

import { useAtom } from 'jotai';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { css } from '@flipster/styled-system/css';
import { Search } from '@flipster/ui';

import { searchTextAtom } from '../jotai';

const GlossaryPageSearch = () => {
  const t = useTranslations();
  const [searchText, setSearchText] = useAtom(searchTextAtom);

  useEffect(() => {
    const nextSearchParams = new URLSearchParams(window.location.search);
    if (nextSearchParams.get('search') === searchText) return;

    if (searchText) {
      nextSearchParams.set('search', searchText);
    } else {
      nextSearchParams.delete('search');
    }
    window.history.replaceState(null, '', `?${nextSearchParams}${window.location.hash}`);
  }, [searchText]);

  return (
    <Search
      className={css({ minW: { tablet: 300 } })}
      value={searchText}
      placeholder={t('Autogen_common.r251126.s_Search_keyword')}
      onChange={setSearchText}
      withClear
      autoFocus
    />
  );
};

export default GlossaryPageSearch;
